module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  Util.each(foreigns, function (foreign) { 
    ; __append("\n<div class=\"foreign\">\n	<div class=\"title\">\n		")
    ; __append(escapeFn( foreign.name ))
    ; __append("\n	</div>\n	<div>\n		")
    ; __append(escapeFn( foreign.value ))
    ; __append("\n	</div>\n</div>\n")
    ;  }); 
  }
  return __output.join("");

}